<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <span class="title">
        {{ "Site carbon objective" | translate }}
      </span>
    </nb-card-header>

    <nb-card-body>
      <div class="form-group">
        <!-- SITE CONCERNED -->
        <div class="form-field">
          <label for="site">{{ 'Concerned site' | translate }}</label>
          <input
            nbInput
            id="site"
            type="text"
            formControlName="site"
            [status]="form.get('site').invalid ? 'danger' : 'basic'"
            readonly
            style="background-color: #f8f9fa; border: 1px solid #e9ecef; color: #495057;"
          >
        </div>

        <!-- BUILDING (PERIMETER) -->
        <div class="form-field">
          <label for="perimeter">{{ 'Concerned building' | translate }}</label>
          <nb-select
            id="perimeter"
            class="perimeter-select"
            formControlName="perimeter"
            [status]="form.get('perimeter').invalid ? 'danger' : 'basic'"
            >
            @for (perimeter of perimeters$ | async; track perimeter) {
              <nb-option [value]="perimeter.id">
                {{ perimeter.name }}
              </nb-option>
            }
          </nb-select>
        </div>

        <div class="form-field">
          <label for="area">{{ 'Area' | translate }}</label>
          <input
            nbInput
            id="area"
            type="text"
            formControlName="area"
            [status]="form.get('area').invalid ? 'danger' : 'basic'"
            readonly
            style="background-color: #f8f9fa; border: 1px solid #e9ecef; color: #495057;"
          >
        </div>

        <!-- YEAR CONCERNED -->
        <div class="form-field">
          <label for="year">{{ 'Concerned year' | translate }}</label>
          <nb-select
            id="year"
            formControlName="year"
            [status]="form.get('year').invalid ? 'danger' : 'basic'"
            placeholder="{{ 'Select year' | translate }}"
            style="width: 100px;"
          >
            <nb-option value="2030">2030</nb-option>
            <nb-option value="2040">2040</nb-option>
            <nb-option value="2050">2050</nb-option>
          </nb-select>
        </div>

        <!-- OBJECTIVE TYPE -->
        <div class="form-field">
          <label for="objective_type">{{ 'Objective type' | translate }}</label>
          <input
            nbInput
            id="objective_type"
            type="text"
            formControlName="objective_type"
            [status]="form.get('objective_type').invalid ? 'danger' : 'basic'"
            [value]="'Objectif carbone personnalisé pour le site'"
            readonly
            style="background-color: #f8f9fa; border: 1px solid #e9ecef; color: #495057;"
          >
        </div>

        <!-- OBJECTIVE VALUE -->
        <div class="form-field">
          <label for="objective_value">{{ 'Objective in kg eq CO2 / m2' | translate }}</label>
          <input
            nbInput
            id="objective_value"
            type="number"
            formControlName="objective_value"
            [status]="form.get('objective_value').invalid ? 'danger' : 'basic'"
            placeholder="{{ 'Enter objective value' | translate }}"
          >
        </div>
      </div>
    </nb-card-body>

    <!-- CANCEL OR SUBMIT -->
    <nb-card-footer class="text-right">
      @if (!loading) {
        <button nbButton type="button" (click)="close()" class="cancel">
          {{ 'Cancel' | translate }}
        </button>
        <button nbButton type="submit" [disabled]="!form.valid || isSelectedAreaInvalid || isObjectiveValueZero" class="ms-3">
          {{ 'OK' | translate }}
        </button>
      }
    </nb-card-footer>
  </nb-card>
</form>
